export default __webpack_public_path__ + "static/media/manual-cashin-instruction.a2cf853a.png";